export const gingerTeaSuggestedClasses = {
  "Home & Living": [
    "a sofa",
    "a table",
    "a chair",
    "a bed",
    "a sideboard",
    "a picture frame",
    "a lamp",
    "a cushion",
    "a bed sheet",
    "a shelf",
    "a vase",
    "a storage box",
    "a dining table set",
    "a coffee table",
    "a dresser",
    "a nightstand",
    "a rug",
    "a bookcase",
    "a ceiling fan",
    "a wall clock",
    "a mattress",
    "a duvet cover",
    "a curtain",
    "a dishwasher",
    "a wine rack",
    "a laundry basket",
    "a trash can",
  ],
  fashion: [
    "a shirt",
    "a dress",
    "a pair of jeans",
    "a sneaker",
    "a handbag",
    "a necklace",
    "a belt",
    "a wallet",
    "a scarf",
    "a pair of sunglasses",
    "a hat",
    "a watch",
    "a pair of gloves",
    "a pair of socks",
    "a headband",
    "a hair clip",
    "a bracelet",
    "a pair of earrings",
    "a pair of boots",
    "a pair of heels",
    "a jacket",
    "a coat",
    "a hoodie",
    "a blazer",
    "a pair of leggings",
    "a pair of trousers",
    "a pair of sandals",
    "a swimwear",
    "a sports bra",
    "a clutch",
    "a tote bag",
    "a backpack",
  ],
};

export const allGingerTeaSuggestedClasses = Object.values(
  gingerTeaSuggestedClasses,
).flat();
